import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card bg-white border-0" }
const _hoisted_2 = { class: "card-body p-25" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 mb-4" }
const _hoisted_5 = { class: "d-flex gap-3 mt-2" }
const _hoisted_6 = { class: "form-check" }
const _hoisted_7 = ["name", "checked", "onChange"]
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = ["name", "checked", "onChange"]
const _hoisted_10 = { class: "col-md-6 mb-3" }
const _hoisted_11 = { class: "col-md-6 mb-3" }
const _hoisted_12 = { class: "col-md-6 mb-3" }
const _hoisted_13 = { class: "col-md-6 mb-3" }
const _hoisted_14 = { class: "col-md-6 mb-3" }
const _hoisted_15 = { class: "col-md-6 mb-3" }
const _hoisted_16 = { class: "col-12 mb-3" }
const _hoisted_17 = { class: "col-12 mt-4" }
const _hoisted_18 = { class: "card border-primary shadow-sm" }
const _hoisted_19 = {
  class: "card-header text-white d-flex justify-content-between align-items-center",
  style: {"background":"linear-gradient(135deg, #0a59a4 0%, #0d6ebd 100%)"}
}
const _hoisted_20 = { class: "card-body p-3" }
const _hoisted_21 = {
  key: 0,
  class: "text-center py-5 text-muted"
}
const _hoisted_22 = { class: "card border" }
const _hoisted_23 = { class: "card-body p-3" }
const _hoisted_24 = { class: "row align-items-start" }
const _hoisted_25 = { class: "col-md-3 mb-2 mb-md-0" }
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_28 = { class: "col-md-3 mb-2 mb-md-0" }
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_31 = { class: "col-md-2 mb-2 mb-md-0" }
const _hoisted_32 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_33 = { class: "col-md-3 mb-2 mb-md-0" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { class: "col-md-1 text-center" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "col-12 mt-4" }
const _hoisted_38 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.addValidationTask,
        "validation-schema": _ctx.schema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "fw-semibold" }, [
                _createTextVNode("Tâche spécifique au dossier ? "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "is_specific" }, {
                default: _withCtx(({ field,handleChange  }) => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: field.name,
                        value: false,
                        checked: _ctx.isSpecificValue === false,
                        onChange: () => { _ctx.isSpecificValue = false; handleChange(false); },
                        id: "specific_no"
                      }, null, 40, _hoisted_7),
                      _cache[1] || (_cache[1] = _createElementVNode("label", {
                        class: "form-check-label fw-medium",
                        for: "specific_no"
                      }, " Non (file de validation) ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: field.name,
                        value: true,
                        checked: _ctx.isSpecificValue === true,
                        onChange: () => { _ctx.isSpecificValue = true; handleChange(true); },
                        id: "specific_yes"
                      }, null, 40, _hoisted_9),
                      _cache[2] || (_cache[2] = _createElementVNode("label", {
                        class: "form-check-label fw-medium",
                        for: "specific_yes"
                      }, " Oui (dossier spécifique) ", -1))
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "is_specific",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "fw-semibold" }, [
                _createTextVNode("libelle Tâche "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "libelle" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("input", _mergeProps({
                    type: "libelle",
                    class: "form-control"
                  }, field), null, 16)
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "libelle",
                class: "text-danger"
              })
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_11, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "fw-semibold" }, [
                _createTextVNode("File de validation "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "validationqueue" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps(field, {
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                    options: _ctx.queueOptions,
                    label: "label",
                    "track-by": "value",
                    placeholder: "Sélectionner la file de validation",
                    searchable: ""
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "validationqueue",
                class: "text-danger"
              })
            ], 512), [
              [_vShow, !_ctx.isSpecificValue]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "fw-semibold" }, [
                _createTextVNode("Dossier BESC "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "besc" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps(field, {
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                    options: _ctx.bescOptions,
                    label: "label",
                    "track-by": "value",
                    placeholder: "Sélectionner le BESC",
                    searchable: "",
                    "show-labels": ""
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "besc",
                class: "text-danger"
              })
            ], 512), [
              [_vShow, _ctx.isSpecificValue]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "fw-semibold" }, [
                _createTextVNode("Priorité "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "priority" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps(field, {
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                    options: _ctx.priorityOptions,
                    label: "label",
                    "track-by": "value",
                    placeholder: "Sélectionner la priorité"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "priority",
                class: "text-danger"
              })
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_14, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "fw-semibold" }, [
                _createTextVNode("Agent assigné "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "user" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps(field, {
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                    options: _ctx.userOptions,
                    label: "label",
                    "track-by": "value",
                    placeholder: "Sélectionner l'agent assigné",
                    searchable: "",
                    clearable: ""
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "user",
                class: "text-danger"
              })
            ], 512), [
              [_vShow, _ctx.isSpecificValue]
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "fw-semibold" }, [
                _createTextVNode("Date limite de traitement (SLA) "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "sla_due_at" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("input", _mergeProps({
                    type: "date",
                    class: "form-control"
                  }, field), null, 16)
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "sla_due_at",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "fw-semibold" }, "Description de la tâche", -1)),
              _createVNode(_component_Field, { name: "description" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("textarea", _mergeProps({ class: "form-control" }, field, {
                    rows: "4",
                    placeholder: "Décrivez précisément la tâche à effectuer (ex: Vérifier les scellés, Contrôler les documents douaniers, etc.)..."
                  }), null, 16)
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "description",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                    _createElementVNode("h5", { class: "mb-0 text-white" }, [
                      _createElementVNode("i", { class: "fas fa-check-circle me-2" }),
                      _createTextVNode(" Liste des contrôles (Checks) ")
                    ]),
                    _createElementVNode("small", { class: "opacity-75" }, "Définissez les contrôles à effectuer pour cette tâche")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light btn-sm",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addCheck && _ctx.addCheck(...args))),
                    title: "Ajouter un contrôle"
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("i", { class: "fas fa-plus-circle me-1" }, null, -1),
                    _createTextVNode(" Ajouter un check ", -1)
                  ]))])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "row fw-bold text-muted mb-2 d-none d-md-flex" }, [
                    _createElementVNode("div", { class: "col-md-3" }, "Code du contrôle"),
                    _createElementVNode("div", { class: "col-md-3" }, "Titre"),
                    _createElementVNode("div", { class: "col-md-2" }, "Type"),
                    _createElementVNode("div", { class: "col-md-3" }, "Description"),
                    _createElementVNode("div", { class: "col-md-1 text-center" }, "Action")
                  ], -1)),
                  _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "mt-0 mb-3" }, null, -1)),
                  (_ctx.checks.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("i", { class: "fas fa-clipboard-list fa-3x mb-3 opacity-50" }, null, -1),
                        _createElementVNode("p", { class: "mb-0" }, "Aucun contrôle défini. Cliquez sur \"Ajouter un check\" pour commencer.", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checks, (check, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "mb-3"
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block d-md-none fw-semibold small text-muted" }, "Code", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((check.check_code) = $event),
                                class: _normalizeClass({'form-control': true, 'is-invalid': _ctx.validateCheck(check.check_code)}),
                                placeholder: "Ex: DOC_INVOICE_PRESENT"
                              }, null, 10, _hoisted_26), [
                                [_vModelText, check.check_code]
                              ]),
                              (_ctx.validateCheck(check.check_code))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, " Le code est obligatoire "))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block d-md-none fw-semibold small text-muted" }, "Titre", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((check.title) = $event),
                                class: _normalizeClass({'form-control': true, 'is-invalid': _ctx.validateCheck(check.title)}),
                                placeholder: "Ex: Facture commerciale fournie"
                              }, null, 10, _hoisted_29), [
                                [_vModelText, check.title]
                              ]),
                              (_ctx.validateCheck(check.title))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Le titre est obligatoire "))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block d-md-none fw-semibold small text-muted" }, "Type", -1)),
                              _createVNode(_component_Multiselect, {
                                modelValue: check.check_type,
                                "onUpdate:modelValue": ($event: any) => ((check.check_type) = $event),
                                options: _ctx.checkTypeOptions,
                                label: "label",
                                "track-by": "value",
                                placeholder: "Type",
                                class: _normalizeClass({'is-invalid': _ctx.validateCheck(check.check_type)})
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "class"]),
                              (_ctx.validateCheck(check.check_type))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Le type est obligatoire "))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block d-md-none fw-semibold small text-muted" }, "Description", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": ($event: any) => ((check.description) = $event),
                                class: "form-control",
                                rows: "2",
                                placeholder: "Description détaillée..."
                              }, null, 8, _hoisted_34), [
                                [_vModelText, check.description]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block d-md-none fw-semibold small text-muted" }, "Action", -1)),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-sm",
                                onClick: ($event: any) => (_ctx.removeCheck(index)),
                                title: "Supprimer ce contrôle"
                              }, [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                              ]))], 8, _hoisted_36)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                class: "btn btn-success me-2",
                type: "submit",
                disabled: _ctx.isSubmitting
              }, [
                _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Création en cours...' : 'Créer la tâche'), 1)
              ], 8, _hoisted_38),
              _createVNode(_component_router_link, {
                to: "/listevalidationtasks",
                class: "btn btn-outline-secondary"
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "fas fa-times me-1" }, null, -1),
                  _createTextVNode("Annuler ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}